import { Text, View } from '@react-pdf/renderer';
import { checkObjHasValues } from 'utils';

const Certification = ({ styles, data = [], headerTitle, randomString }: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any, index: any) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`cert-pt2-${res?.title}-${index}`} style={styles.detailBox}>
								<View style={styles.detailBoxContent}>
									<Text style={styles.detailText}>{res?.title}</Text>
									{res?.year && <Text style={styles.detailSubText}>in {res.year}</Text>}
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Certification;
